// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--91de5";
export var pictureWrapper = "Slide-module--pictureWrapper--8cb95";
export var picture = "Slide-module--picture--adbb9";
export var img = "Slide-module--img--891b6";
export var text = "Slide-module--text--f7864";
export var link = "Slide-module--link--388f3";
export var linkText = "Slide-module--linkText--acf26";
export var icon = "Slide-module--icon--2d8d3";
export var position = "Slide-module--position--47d05";
export var description = "Slide-module--description--ad5cf";